import { FiCpu, FiBarChart2 } from "react-icons/fi";
import "./LegacyDashboard.css";
import "./GoogleAnalytics.css";
import "./GoogleSearchConsole.css";

export default function SearchConsoleHeader({
  gscMode,
  setGscMode,
  userProfile,
  gscSiteUrl,
  gscSitesList = [],
  handleSelectGSCSite,
  gscPeriodDays = 28,
  setGscPeriodDays,
  fetchGoogleSearchConsoleData,
  handleDisconnectGSC,
  actionLoading = false,
  gscLoading = false,
}) {
  const currentSite = userProfile?.gsc_site_url || gscSiteUrl || "";

  return (
    <div className="dashboard-card gaty-header-card p-3 p-md-4 mb-3">
      <div className="d-flex flex-column flex-lg-row justify-content-between align-items-lg-center gap-3">
        <div>
          <div className="d-flex align-items-center gap-2 flex-wrap">
            <h1 className="gaty-title-main mb-0" style={{ fontSize: "20px" }}>
              {gscMode === "ai" ? "Google Search Intelligence" : "Google Search Console"}
            </h1>
            <span className="badge gaty-connected-badge py-1 px-2.5 d-inline-flex align-items-center gap-2 rounded-pill">
              <span className="gaty-badge-dot"></span> GSC Connected
            </span>
          </div>
          <p className="text-muted mb-0 mt-1" style={{ fontSize: "13px" }}>
            {gscMode === "ai"
              ? `Proprietary SeenByAI analysis for ${currentSite || "your website"}`
              : "Live search performance metrics and verified keywords from Google Search Console."}
          </p>
        </div>

        <div className="d-flex align-items-center gap-2.5 flex-wrap">
          {setGscMode && (
            <div className="mode-switch-slider-wrap me-2" role="group" aria-label="GSC View Mode">
              <div
                className={`mode-switch-slider-bg ${
                  gscMode === "ai" ? "is-ai" : "is-legacy"
                }`}
              />
              <button
                type="button"
                className={`mode-switch-btn ${gscMode === "ai" ? "active" : ""}`}
                onClick={() => setGscMode("ai")}
                title="Switch to AI Mode"
              >
                <FiCpu size={14} />
                <span>AI Mode</span>
              </button>
              <button
                type="button"
                className={`mode-switch-btn ${gscMode === "legacy" ? "active" : ""}`}
                onClick={() => setGscMode("legacy")}
                title="Switch to Legacy Mode"
              >
                <FiBarChart2 size={14} />
                <span>Legacy</span>
              </button>
            </div>
          )}

          {gscSitesList && gscSitesList.length > 0 && handleSelectGSCSite ? (
            <select
              className="form-select form-select-sm"
              style={{ maxWidth: "220px", fontSize: "12px", borderRadius: "6px" }}
              value={currentSite}
              disabled={gscLoading || actionLoading}
              onChange={(e) => {
                if (e.target.value) handleSelectGSCSite(e.target.value);
              }}
              title="Select Google Search Console property"
            >
              {gscSitesList.map((s) => (
                <option key={s.site_url} value={s.site_url}>
                  {s.site_url}
                </option>
              ))}
            </select>
          ) : (
            <span className="text-muted" style={{ fontSize: "12px", marginRight: "6px" }}>
              Site: <strong className="text-primary">{currentSite || "None Selected"}</strong>
            </span>
          )}

          <select
            className="form-select form-select-sm gaty-period-select"
            value={gscPeriodDays}
            disabled={gscLoading}
            onChange={(e) => {
              const newDays = parseInt(e.target.value, 10);
              if (setGscPeriodDays) setGscPeriodDays(newDays);
              if (fetchGoogleSearchConsoleData) {
                fetchGoogleSearchConsoleData(userProfile, newDays);
              }
            }}
            style={{ width: "120px", borderRadius: "6px", fontSize: "12px" }}
          >
            <option value={7}>Last 7 Days</option>
            <option value={14}>Last 14 Days</option>
            <option value={28}>Last 28 Days</option>
            <option value={60}>Last 60 Days</option>
            <option value={90}>Last 90 Days</option>
          </select>

          {handleDisconnectGSC && (
            <button
              className="btn btn-outline-danger btn-sm fw-semibold"
              style={{ borderRadius: "6px", fontSize: "12px" }}
              onClick={handleDisconnectGSC}
              disabled={actionLoading}
            >
              Disconnect
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
